import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useClientSelectors } from "./useClientSelectors";

const UseBrowserInfo = () => {
  const [browserData, setBrowserData] = useState([]);
  const { t } = useTranslation();
  const { info } = useClientSelectors();

  useEffect(() => {
    if (info) {
      const newData = [
        { label: t("browserInfo.type"), value: t("browserInfo.result") },
        {
          label: "User Agent",
          value: info.userAgent,
        },
        { label: "JavaScript", value: "1.5" },
        {
          label: "VBScript",
          value: info.isVBScript ? t("global.yes") : t("global.no"),
        },
        {
          label: "Flash",
          value: info.flash ? t("global.yes") : t("global.no"),
        },
        {
          label: "Java",
          value: info.java ? t("global.yes") : t("global.no"),
        },
        {
          label: "Screen",
          value: [
            `${t("browserInfo.resolution")}: ${info.screen} (${t("browserInfo.desktop")}: ${info.screen})`,
            `${t("browserInfo.colorDepth", { value: info.color })}`,
            `DPI: ${Math.ceil(info.dpi)}`,
          ],
        },
        {
          label: "Plugins",
          value: [
            "PDF Viewer (Portable Document Format)",
            "Chrome PDF Viewer (Portable Document Format)",
            "Chromium PDF Viewer (Portable Document Format)",
            "Microsoft Edge PDF Viewer (Portable Document Format)",
            "WebKit built-in PDF (Portable Document Format)",
          ],
        },
      ];

      setBrowserData(newData);
    }
  }, [t, info]);

  return browserData;
};

export default UseBrowserInfo;
